import ReactDOM from "react-dom/client";
import Routes from "./routes";

import "./index.css";

const root = ReactDOM.createRoot(document.getElementById("root"));

root.render(<Routes />);
